<template>
  <Header12 />
  <div class="body">
    <section class="background-bleu">
      <MenuTitle title="Recrutement" subTitle="" srcImg="/images/pages/recrutement/desc-picture.png"
        backgroundSpan="span-background-blue" />
    </section>
    <section>
      <NavLeft tab="recrutement" breadcrumb1="" breadcrumb2="Recrutement" />
    </section>
    <section class="background-bleu">
      <Expertises />
    </section>
    <section>
      <NousContacter />
    </section>
    <section>
      <Footer :dark_bg="true" />
    </section>
  </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue';
import Expertises from '@/components/emci/Homepage/Nos-expertises/index.vue';
import NousContacter from '@/components/emci/NousContacter/index.vue';
import Footer from '@/components/emci/Footer/index.vue'
import MenuTitle from "../../MenuTitle";
import NavLeft from "@/components/emci/NavLeft/index.vue"
useHead({
  title: "EMCI - Expertise et accompagnement en recrutement",
  meta: [
    {
      name: "description",
      content: "De la compréhension de vos besoins à l’intégration réussie du nouveau collaborateur, EMCI vous accompagnons tout au long de ce process"
    }
  ]
})
</script>

<style scoped>
.body {

  overflow: hidden !important;
  margin-top: 120px;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .body {
    margin-top: 85px;
  }

  .background-bleu {
    margin-bottom: 50px;
  }
}
</style>